export default __webpack_public_path__ + "static/media/flexline_black_logo_de.d82dc1bb.png";